// extracted by mini-css-extract-plugin
export var bodySections = "_dx-8";
export var gray = "_dx-7";
export var green = "_dx-4";
export var iconContainer = "_dx-9";
export var iconWidgetContainer = "_dx-1";
export var phoneIcon = "_dx-2";
export var red = "_dx-5";
export var statusDot = "_dx-3";
export var widgetContainer = "_dx-0";
export var yellow = "_dx-6";